"use client";

import { Placeholder } from "@lmn/design-system";
import { parseISO } from "date-fns";
import styled from "styled-components";
import IconCross from "@lmn/lastminute-react-icons/icons-converted/lastminute-icons-solid/IconCross.js";
import {
  Content,
  CalendarContainer,
  BarsWrapper,
  NavButton,
  DismissButton,
} from "./PriceCurveStyles";

const BarSlot = styled.div({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  minWidth: "70px",
});

const BarArea = styled.div({
  display: "flex",
  alignItems: "flex-end",
  height: "120px",
});

const BarPlaceholder = styled(Placeholder)({
  borderRadius: "4px 4px 0 0",
});

const DatePlaceholder = styled(Placeholder)({
  marginTop: "8px",
});

const BAR_HEIGHTS = [
  80, 110, 130, 95, 70, 100, 120, 85, 105, 90,
  115, 75, 95, 125, 80, 110, 70, 100, 130, 85,
];

function formatSelectionDate(dateStr: string) {
  const date = parseISO(dateStr);
  return date.toLocaleDateString("de-DE");
}

interface PriceCurveSkeletonProps {
  selectedDate?: string | null;
  onClearSelection?: () => void;
}

export default function PriceCurveSkeleton({
  selectedDate,
  onClearSelection,
}: PriceCurveSkeletonProps) {
  return (
    <Content>
      <CalendarContainer>
        <NavButton $disabled aria-hidden />
        <BarsWrapper>
          {BAR_HEIGHTS.map((h, i) => (
            <BarSlot key={i}>
              <BarArea>
                <BarPlaceholder width="70px" height={`${h}px`} />
              </BarArea>
              <DatePlaceholder width="40px" height="32px" />
            </BarSlot>
          ))}
        </BarsWrapper>
        <NavButton $disabled aria-hidden />
      </CalendarContainer>

      {selectedDate && onClearSelection && (
        <DismissButton
          variant="secondary"
          appearance="outlined"
          iconTrailing={IconCross}
          iconSize={14}
          aria-label="Auswahl entfernen"
          onClick={onClearSelection}
        >
          Hinreise: {formatSelectionDate(selectedDate)}
        </DismissButton>
      )}
    </Content>
  );
}
